import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Avatar, Text } from '@Sage/hoi-poi-ui';

import { getSrcUserCircleAvatar } from 'utils/getSrcAvatar';

const IntegrationSelectedUserItem = memo(({ id, text, info2, info3 }) => {
    const userAvatar = getSrcUserCircleAvatar(id);
    const hasEmail = info3 !== 'NO EMAIL';

    return (
        <div className="integration-selected-user-item">
            <Avatar
                alt={text}
                className="integration-selected-user-item__avatar"
                placeholder={userAvatar.fallbackSrc}
                src={userAvatar.src}
                type="round"
            />
            <div className="integration-selected-user-item__details">
                <Text className="integration-selected-user-item__name" medium type="body">
                    {text}
                </Text>
                <Text className="integration-selected-user-item__meta" type="caption">
                    {info2}
                </Text>
                <Text
                    className={classnames('integration-selected-user-item__meta', {
                        'integration-selected-user-item__email--missing': !hasEmail,
                    })}
                    type="caption"
                >
                    {info3}
                </Text>
            </div>
        </div>
    );
});

IntegrationSelectedUserItem.displayName = 'IntegrationSelectedUserItem';

IntegrationSelectedUserItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    info2: PropTypes.string,
    info3: PropTypes.string,
    text: PropTypes.string.isRequired,
};

export default IntegrationSelectedUserItem;
